module.exports = __webpack_public_path__ + "static/media/participant_status_invitation.2becb52b.svg";